export const GET_ALL_SUPPLIERS = "GET_ALL_SUPPLIERS"
export const GET_ALL_SUPPLIERS_RESPONSE_SUCCESS =
  "GET_ALL_SUPPLIERS_RESPONSE_SUCCESS"
export const CREATE_SUPPLIER = "CREATE_SUPPLIER"
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER"
